export const Year: React.FC = () => <>{new Date().getFullYear()}</>;